import { JobModel, JobModelHttp } from '@data/models/job-model.interface';

export const toJobModel = (jobModel: Partial<JobModelHttp>): JobModel => {
  return {
    id: jobModel.id || '',
    codeQualification: jobModel.attributes?.code_qualification || null,
    libelleQualification: jobModel.attributes?.libelle_qualification || null,
    modeleCode: jobModel.attributes?.modele_code || 0,
    modeleDesignation: jobModel.attributes?.modele_designation || '',
    coefficient: jobModel.attributes?.coefficient || null,
    salaireReference: jobModel.attributes?.salaire_reference || null,
    codeChantier: jobModel.attributes?.code_chantier || null,
    clientAtlasId: jobModel.attributes?.client_atlas_id || '',
    source: jobModel.attributes?.source || '',
  };
};
